import { useAuth } from '../contexts/AuthContext';

// Whether the signed-in user's club can take card payments. Anything the
// server hasn't said counts as yes; the server refuses anyway if not.
export function useCardPayments() {
  let user = null;
  // eslint-disable-next-line react-hooks/rules-of-hooks
  try { user = useAuth()?.user ?? null; } catch { user = null; }
  return user?.cardPayments !== false;
}

// True when card payments are off because the club's Run The Club bill is unpaid
export function useBillingOverdue() {
  let user = null;
  // eslint-disable-next-line react-hooks/rules-of-hooks
  try { user = useAuth()?.user ?? null; } catch { user = null; }
  return user?.billingOverdue === true && user?.cardPayments === false;
}
